// Identify the shopper to Klaviyo once its onsite script has loaded: from a `utm_email` link,
// and/or from the logged-in customer's email.
function readEmail() {
    try {
        return JSON.parse(document.querySelector('[data-klaviyo-identify]')?.textContent || '{}').email || '';
    } catch (e) {
        return '';
    }
}

function send() {
    const {_learnq} = window;
    if (location.search && location.search.indexOf('utm_email=') > -1) {
        _learnq.identify();
    }
    const email = readEmail();
    if (email) {
        _learnq.push(['identify', {$email: email}]);
    }
}

(function waitForKlaviyo() {
    const {_learnq} = window;
    if (typeof _learnq !== 'object' || !_learnq.identify) {
        setTimeout(waitForKlaviyo, 20);
        return;
    }
    setTimeout(send, 500);
})();
